import 'es6-promise/auto';
import Vue from 'vue';
import Ionic from '@ionic/vue';
import DateFilter from './filters/date';

import App from './App.vue';
import router from './router.js';
import store from './store/';
import each from 'lodash/each';

import '@ionic/core/css/ionic.bundle.css';

Vue.config.productionTip = false;

Vue.use(Ionic);

Vue.filter('date', DateFilter );

const CustomBackButton = () => import('./components/custom-back-button/index.vue');

const GLOBAL_COMPONENTS = {
    CustomBackButton,
};

each(GLOBAL_COMPONENTS, (value, key) => {
    Vue.component(key, value);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
